import * as yup from 'yup'

export const signinSchema = yup.object().shape({
  firstName: yup.string().required('first name is required'),
  lastName: yup.string().required('last name is required'),
  // estateName: yup.string().required("Estate name is required"),
  email: yup.string().email().required('Email is required'),
  password: yup
    .string()
    .test(
      'password-match',
      'Password must contain at least 1 letter and 1 number',
      function (value) {
        return /(?=.*\d)(?=.*[a-zA-Z]).{8,}/.test(value || '')
      }
    )
    .required('Password is required'),
  // estateAddress: yup.string().required("Estate address is required"),
  address: yup.string().required('Address is required'),
  phone: yup.string().required('Phone is required'),
  confirmPassword: yup
    .string()
    .test('confirm-password', 'Password must match', function (value) {
      return this.parent.password === value
    }),
})
